'use client';

import { useFeatureFlag } from '../../statsig/sdk/provider';
import { useModalDrawerContext } from '../../common/components/ModalDrawerContext/ModalDrawerContext';
import { AssetRisksDrawer } from './AssetRisksDrawer.use-client';
import { PerformanceDisclaimerTranslations, DisclaimerVariant } from '../types';
import {
  disclaimerBannerStyles,
  assetRisksLinkStyles,
  disclaimerWrapperStyles,
} from '../styles';

interface PerformanceDisclaimerBannerProps {
  translations: PerformanceDisclaimerTranslations;
  variant: DisclaimerVariant;
  /** The translated period string (e.g. "24h", "7 days"). Required when variant is 'dynamic'. */
  period?: string;
  /** Optional className to override the default wrapper styles. */
  className?: string;
}

const PerformanceDisclaimerBanner = ({
  translations,
  variant,
  period,
  className,
}: PerformanceDisclaimerBannerProps) => {
  const { openDrawer } = useModalDrawerContext();

  const feature_isUkLicensed = useFeatureFlag('feature_isUkLicensed');

  if (!feature_isUkLicensed) {
    return null;
  }

  const disclaimerText =
    variant === 'dynamic' && period
      ? translations.disclaimerDynamic.replace('{{period}}', period)
      : translations.disclaimerFixed;

  const handleAssetRisksClick = () => {
    openDrawer(
      () => (
        <AssetRisksDrawer
          title={translations.assetRisksTitle}
          body={translations.assetRisksBody}
          ctaLabel={translations.assetRisksCta}
        />
      ),
      { position: 'bottom' },
    );
  };

  return (
    <div className={className ?? disclaimerWrapperStyles}>
      <p className={disclaimerBannerStyles}>
        {disclaimerText}{' '}
        <button
          type="button"
          className={assetRisksLinkStyles}
          onClick={handleAssetRisksClick}
        >
          {translations.assetSpecificRisks}
        </button>
      </p>
    </div>
  );
};

export { PerformanceDisclaimerBanner };
